import { useMemo } from "react";
import { Dayjs } from "dayjs";
import getCheckOutDate from "../configs/checkoutDateRules";
import { useAppSelector } from "./reduxHooks";
import { IDateHookResult } from "./useSpecialDate";

const defaultWorkingDays = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];

const parseTime = (time: string) => {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hours, minutes, seconds, 0);
  return date;
};

export const useRegularDate = (): IDateHookResult => {
  const storeConfig = useAppSelector(
    (state) => state.store.getStoreConfigResponse
  );
  const storeConfigError = useAppSelector(
    (state) => state.store.getStoreConfigError
  );

  const isReady = !!storeConfig || !!storeConfigError;

  const regularDate: Dayjs = useMemo(() => {
    const body = storeConfig?.body;

    return getCheckOutDate({
      isSpecialDay: false,
      checkInCutOffTime: parseTime(body?.cutOffTime || "10:00:00"),
      pickupTime: parseTime(body?.pickupTime || "15:00:00"),
      workingDays: body?.workingDays || defaultWorkingDays,
      generalServiceDays: body?.daysToDeliver ?? 2,
      specialServiceDays: body?.specialDaysToDeliver ?? 0,
    });
  }, [storeConfig]);

  return { date: regularDate, isReady };
};
